// Copyright (c) 2020 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import facetFilterText from './facet-filter-text';
import filteredTerritories from './filtered-territories';
import reportsAccordion from './reports-accordion';
import searchByDropDown from './search-by-dropdown';
import searchQueryString from './search-query-string';
import selectedSpaLevels from './selected-spa-levels';
import specialAllowanceClaims from './special-allowance-claims';
import specialAllowanceClaimsSearchFilters from './spa-claims-search-filters';
import tcsmSettings from './tcsm-settings';
import wipFacets from './wip-facets';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    facetFilterText,
    filteredTerritories,
    reportsAccordion,
    searchByDropDown,
    searchQueryString,
    selectedSpaLevels,
    specialAllowanceClaims,
    specialAllowanceClaimsSearchFilters,
    tcsmSettings,
    wipFacets
});



// WEBPACK FOOTER //
// ./src/tabm/wip/reducers/index.js